<template>
  <div class="bq-product-zhfw">
    <div class="bq-product-banner">
      <div
        class="bq-banner-cover"
        :style="{ backgroundImage: `url(${cover})` }"
      >
        <div class="bq-product-title-wrap" :class="animateTitle">
          <div
            class="bq-product-title"
            :style="{ backgroundImage: `url(${titlebg})` }"
          ></div>
          <div class="bq-product-line" v-show="false"></div>
          <div class="bq-product-subtitle">
            以“互联网+”为手段，搭建智慧服务平台，围绕患者医疗服务需求，覆盖诊前、诊中、诊后对线上/线下诊疗全流程，提高区域/医院智慧服务水平，提升患者就医体验
          </div>
        </div>
      </div>
    </div>
    <div class="bq-product-content">
      <BqTab
        :tabs="tabs"
        :layout="'vertical'"
        :activeIndex="activeIndex"
        @handleClick="handleClick"
      >
        <div v-for="item in tabs" :key="item.slot" :slot="item.slot">
          <keep-alive>
            <component :is="item.slot"></component>
          </keep-alive>
        </div>
      </BqTab>
    </div>
  </div>
</template>
<script>
import BqTab from '@/components/website_v3/Tab';
import jkmh from './jkmh';
import zndz from './zndz';
import zqzs from './zqzs';
import yyzs from './yyzs';
import jkgl from './jkgl';
import hlwyy from './hlwyy';
import tyzf from './tyzf';
import yhf from './yhf';
import qlcsl from './qlcsl';

export default {
  name: 'Zhfw',
  components: {
    BqTab,
    jkmh,
    zndz,
    zqzs,
    yyzs,
    jkgl,
    hlwyy,
    tyzf,
    yhf,
    qlcsl,
  },
  data() {
    return {
      animateTitle: [],
      activeIndex: 0,
      titlebg:
        'https://img.alicdn.com/tfs/TB1.NomF7T2gK0jSZPcXXcKkpXa-291-48.png',
      cover:
        'https://img.alicdn.com/tfs/TB1oI1tE.H1gK0jSZSyXXXtlpXa-1920-380.png',
      tabs: [
        {
          title: '健康门户',
          slot: 'jkmh',
        },
        {
          title: '智能导诊',
          slot: 'zndz',
        },
        {
          title: '诊前助手',
          slot: 'zqzs',
        },
        {
          title: '用药助手',
          slot: 'yyzs',
        },
        {
          title: '健康管理',
          slot: 'jkgl',
        },
        {
          title: '互联网医院',
          slot: 'hlwyy',
        },
        {
          title: '统一支付对账平台',
          slot: 'tyzf',
        },
        {
          title: '医后付/信用付',
          slot: 'yhf',
        },
        {
          title: '全流程刷脸就医',
          slot: 'qlcsl',
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.animateTitle = ['animate-title'];
    }, 10);
  },
  methods: {
    handleClick() {},
  },
};
</script>
<style lang="less" scoped>
@import '../../../../assets/styles/fn.less';

.bq-product-zhfw {
  .bq-product-banner {
    position: relative;
    width: 100%;
    height: 380px;
    overflow: hidden;
    color: #fff;

    .bq-banner-cover {
      width: 100%;
      height: 100%;
      .bgNoImg();
      position: relative;
      .bq-product-title-wrap {
        margin: 0 auto;
        position: absolute;
        top: 110px;
        // right: 360px;
        right: 58%;
        transform: translateX(50%);

        &.animate-title {
          .bq-product-title {
            animation: bounce 1s linear;

            @keyframes bounce {
              0% {
                opacity: 0;
                transform: translate3d(0, 500%, 0);
              }

              60% {
                transform: translate3d(0, -30px, 0);
              }

              80% {
                transform: translate3d(0, -10px, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }

          .bq-product-subtitle {
            transform: translate3d(0, 0, 0);
            opacity: 1;

            animation: leftslide 1s ease;

            @keyframes leftslide {
              0% {
                opacity: 0;
                transform: translate3d(500%, 0, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }
        }
      }

      .bq-product-title {
        // opacity: 0;
        margin-bottom: 50px;
        width: 313px;
        height: 51px;
        background-repeat: no-repeat;
        background-size: 100%;
      }

      .bq-product-line {
        width: 900px;
        height: 1px;
        background-color: #fff;
        box-shadow: 0 6px 2px 0 #00266f;
        margin-bottom: 20px;
      }
      .bq-product-subtitle {
        opacity: 0;
        width: 900px;
        text-align: left;
        font-size: 18px;
      }
    }
  }
  .bq-product-content {
    padding: 90px 0;
  }
}
</style>
